import{_ as r}from"./_rollupPluginBabelHelpers-c245b26a.js";import*as e from"react";import{styled as o}from"@linaria/react";const s=o("span")({name:"StyledDot",class:"s1lvq0rs",propsAsIs:!1}),t=o=>e.createElement(s,r({},o,{role:"button"}));export{t as Dot};
//# sourceMappingURL=Dot.js.map
